import { Col, Form, Input, Row, Select, Switch } from 'antd'
import type { CustomerUpsertInput } from '@super-mega/server/contracts/customer'
import { CUSTOMER_GROUPING_DAY_OPTIONS } from '@/features/master-data/const/customer-form.ts'

export function CustomerMonthlyBillingFields({ disabled, compact = false }: { disabled?: boolean; compact?: boolean }) {
  const form = Form.useFormInstance<CustomerUpsertInput>()
  const groupingDay = Form.useWatch('collectionBillGroupingDay', form)
  const automatic = Form.useWatch('autoCollectionBillGrouping', form)
  return (
    <Row gutter={16}>
      <Col sm={compact ? 24 : 12} xs={24}>
        <Form.Item
          label="每月归组日"
          name="collectionBillGroupingDay"
          extra="选填；设置后用于客户台历提醒。清空日期会关闭自动生成和自动发送。"
          rules={[{ type: 'number', min: 1, max: 28 }]}
        >
          <Select
            allowClear
            disabled={disabled}
            options={CUSTOMER_GROUPING_DAY_OPTIONS}
            placeholder="可留空，或选择 1～28 日"
            onClear={() => {
              form.setFieldsValue({ autoCollectionBillGrouping: false, autoSendCollectionBillGroup: false })
            }}
          />
        </Form.Item>
      </Col>
      <Col sm={compact ? 24 : 12} xs={24}>
        <Form.Item
          label="自动生成收款账单组"
          name="autoCollectionBillGrouping"
          valuePropName="checked"
          extra="先设置归组日；每月该日北京时间 08:00，按经营主体生成上月未收账单组草稿。"
        >
          <Switch
            disabled={disabled || !groupingDay}
            checkedChildren="开启"
            unCheckedChildren="关闭"
            onChange={(checked) => {
              if (!checked) form.setFieldValue('autoSendCollectionBillGroup', false)
            }}
          />
        </Form.Item>
      </Col>
      <Col sm={compact ? 24 : 12} xs={24}>
        <Form.Item
          label="自动发送账单组"
          name="autoSendCollectionBillGroup"
          valuePropName="checked"
          extra="须先开启自动生成。本次仅保存发送配置，实际自动发送流程后续接入。"
        >
          <Switch disabled={disabled || !automatic} checkedChildren="开启" unCheckedChildren="关闭" />
        </Form.Item>
      </Col>
      {automatic ? (
        <Col sm={compact ? 24 : 12} xs={24}>
          <Form.Item
            label="自动归组起始月份"
            name="collectionBillGroupingFrom"
            extra="从该费用月份开始自动归组；留空保存时默认上个月。更早欠款可人工补组。"
            rules={[{ pattern: /^\d{4}-(0[1-9]|1[0-2])$/, message: '请输入 YYYY-MM' }]}
          >
            <Input disabled={disabled} placeholder="例如 2026-09" />
          </Form.Item>
        </Col>
      ) : null}
    </Row>
  )
}
